export const delegatorsContainerId = 'delegators'
export const debondingContainerId = 'debonding'
